import { Alert, DrawerBody, DrawerTitle } from '@growtherapy/sprout-ui';

import { ClientQueueWrapper as ClientQueue } from './ClientQueue';
import { ClientsInSessionWrapper as ClientsInSession } from './ClientsInSession';

import './index.css';

import { useAtomValue } from 'jotai';

import { DrawerHeader } from '../../components/DrawerHeader';
import { ConnectionError, syncClientConnectionErrorAtom } from '../../session';
import { RETRYING_CONNECTION_INFO_TEXT, TERMINAL_CONNECTION_ERROR_TEXT } from '../sync';

type ClientsDrawerProps = {
  clientQueueComponent: typeof ClientQueue;
  clientsInSessionComponent: typeof ClientsInSession;
  connectionError?: ConnectionError | null;
};

export function ClientsDrawer({
  clientQueueComponent: ClientQueueComponent,
  clientsInSessionComponent: ClientsInSessionComponent,
  connectionError,
}: ClientsDrawerProps) {
  return (
    <>
      <DrawerHeader data-testid='waiting-room.header'>
        <DrawerTitle>Clients</DrawerTitle>
      </DrawerHeader>
      <DrawerBody className='flex flex-col gap-y-4' data-testid='waiting-room.body'>
        {connectionError ? (
          <Alert
            heading={connectionError.terminal ? TERMINAL_CONNECTION_ERROR_TEXT : RETRYING_CONNECTION_INFO_TEXT}
            use={connectionError.terminal ? 'error' : 'info'}
            headingAs='h3'
          />
        ) : (
          <>
            <ClientQueueComponent />
            <div className='my-4 border-b border-neutral-300' />
            <ClientsInSessionComponent />
          </>
        )}
      </DrawerBody>
    </>
  );
}

export function ClientsDrawerWrapper() {
  const connectionError = useAtomValue(syncClientConnectionErrorAtom);

  return (
    <ClientsDrawer
      clientsInSessionComponent={ClientsInSession}
      clientQueueComponent={ClientQueue}
      connectionError={connectionError}
    />
  );
}
